//#region src/util.ts
const INHOUSE_LTX23_MODEL = "v3.0.2";
const VideoPricingTaskType = {
	I2vPro: "i2vPro",
	ReferenceVideo: "referenceVideo"
};
const VideoPricingMode = {
	Fixed: "fixed",
	PerSecond: "per-second"
};
const isVideoPricingParametersRecord = (value) => {
	return typeof value === "object" && value !== null && !Array.isArray(value);
};
const floorWith = (n, align) => Math.trunc(n / align) * align;
const PriceType = {
	prepaid: "prepaid",
	postpaid: "postpaid"
};
const getPriceMeter = () => {
	const items = [];
	return {
		type: PriceType.prepaid,
		items,
		curPrice: 0,
		discount: 0,
		exp: "",
		addItem(cumulative, { explanation, name, spec, ...item } = {}) {
			const totalPrice = Math.trunc(cumulative(this.curPrice) - this.curPrice);
			if (name != null && spec != null) items.push({
				name,
				spec,
				...item,
				totalPrice
			});
			if (explanation) this.exp = explanation(this.exp);
			this.curPrice += totalPrice;
			if (totalPrice < 0) this.discount -= totalPrice;
		},
		toPriceInfo() {
			return {
				type: this.type,
				items,
				originalPrice: Math.max(0, this.curPrice + this.discount),
				actualPrice: Math.max(0, this.curPrice)
			};
		}
	};
};
const defaults = (source, object) => {
	const result = { ...object };
	for (const key in source) if (result[key] == null) result[key] = source[key];
	return result;
};
const getVideoPricingMode = (config, taskType, model) => {
	if (!model) return void 0;
	return (config?.videoPricing?.modelPricingMode ?? []).find((item) => item.taskType === taskType && item.model === model)?.mode;
};
const lookupVideoPerSecondPriceItem = (config, taskType, parameters) => {
	const matched = (config?.videoPricing?.perSecondPriceList ?? []).filter((item) => {
		if (item.taskType !== taskType) return false;
		const itemParameters = item.parameters;
		if (!isVideoPricingParametersRecord(itemParameters)) return false;
		return Object.entries(itemParameters).every(([key, value]) => parameters[key] === value);
	});
	if (!matched.length) return void 0;
	return matched.sort((a, b) => Object.keys(b.parameters ?? {}).length - Object.keys(a.parameters ?? {}).length)[0];
};
const cloneParameters = (input) => {
	return JSON.parse(JSON.stringify(input));
};
const isModel = (modelType) => {
	return modelType?.includes("MODEL") || false;
};
const isDITModelType = (modelType) => {
	return modelType?.startsWith("DIT") && isModel(modelType) || false;
};
const isDITV7ModelType = (modelType) => {
	return isDITModelType(modelType) && !isDITV9ModelType(modelType);
};
const isDITV9ModelType = (modelType) => {
	return modelType?.startsWith("DIT9") && isModel(modelType) || false;
};
const isDistillModelType = (modelVariant, modelId) => {
	if (modelId === "1934789864939078594") return true;
	return modelVariant === "z1";
};
const isSDOrSDXLModelStrict = (modelType) => {
	if (!modelType) return false;
	return [
		"SD_V1_MODEL",
		"SD3_MEDIUM_MODEL",
		"SDXL_MODEL"
	].includes(modelType);
};
const isSDXLModelStrict = (modelType) => {
	if (!modelType) return false;
	return modelType === "SDXL_MODEL";
};
const isMMDIT26AModelTypeStrict = (modelType) => {
	if (!modelType) return false;
	return modelType === "MMDIT26A_MODEL";
};
//#endregion
export { INHOUSE_LTX23_MODEL, PriceType, VideoPricingMode, VideoPricingTaskType, cloneParameters, defaults, floorWith, getPriceMeter, getVideoPricingMode, isDITModelType, isDITV7ModelType, isDITV9ModelType, isDistillModelType, isMMDIT26AModelTypeStrict, isSDOrSDXLModelStrict, isSDXLModelStrict, isVideoPricingParametersRecord, lookupVideoPerSecondPriceItem };
